<div
  class="modal-wrapper"
  *ngIf="showModal"
  [ngClass]="{ loaded: loaded && loaded['loaded'] }"
>
  <div class="wrapper">
    <div
      class="under-wrapper"
      sdClickOutside
      (clickOutside)="closeModal()"
      #parent
      [parentRef]="parent"
      [ngClass]="{ loaded: loaded && loaded['loaded'] }"
    >
      <div (click)="closeModal()" class="close-button">
        <i class="ai ai-cancel"></i>
      </div>

      <div class="modal-content">
        <p>{{ content }}</p>
      </div>

      <div class="button-wrapper">
        <button class="button small primary-button" (click)="confirmModal()">
          {{ "newsletter.signOutYes" | translate }}
        </button>
        <button class="button small" (click)="closeModal()">
          {{ "newsletter.signOutNo" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
